module.exports = __webpack_public_path__ + "static/media/success_logo.a93d4383.png";